import type { Action as SvelteAction } from 'svelte/action';

export type Action = [SvelteAction | null, object | undefined] | null;

function mockAction() {
    return;
}

export function setActionFunc(action: Action | undefined): {
    actionFunc: SvelteAction<SVGSVGElement | HTMLElement>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    actionParams: any;
} {
    if (action && typeof action[0] === 'function') {
        return { actionFunc: action[0], actionParams: action[1] };
    }

    return { actionFunc: mockAction, actionParams: undefined };
}
